import React, { Component, PropTypes } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';
import { RUNSCRIPT__OUTPUT__REQUESTED } from "../constants/actionTypes";

import moment from "moment";
import 'moment-timezone';

const timezone = 'America/New_York';

class RunscriptOutputsSection extends Component {
    constructor(props) {
        super(props);

        this.handleRunscriptOutput = this.handleRunscriptOutput.bind(this);
    }

    handleRunscriptOutput(event) {
        event.preventDefault();

        const { assignment, user } = this.props,
            assignmentId = assignment.id,
            userId = user.id,
            timestamp = event.target.getAttribute('data-value')
        ;

        this.props.dispatch({
            type: RUNSCRIPT__OUTPUT__REQUESTED,
            payload: {
                assignmentId,
                userId,
                timestamp
            }
        });
    }

    render() {
        const { assignment, runscripts } = this.props;

        return assignment && runscripts ?
        (
            <div className="mt-3 col-md-12">
                {
                    _.map(
                        runscripts, runscript => {
                            const formatted_date = moment(runscript.id * 1000).tz(timezone).format('MM-DD-YYYY h:mm:ss a');

                            return (
                                <button
                                    className="btn btn-link pointer block"
                                    onClick={this.handleRunscriptOutput}
                                    disabled={false}
                                    title={formatted_date}
                                    data-value={runscript.id}
                                    key={runscript.id}
                                >
                                    <i
                                        className="fa fa-download"
                                        aria-hidden="true"
                                    /> {formatted_date}
                                </button>
                            );
                        }
                    )
                }
            </div>
        ) :
            null
        ;
    }
}

RunscriptOutputsSection.propTypes = {
    assignment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    runscripts: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { runscripts } = state;

    return { runscripts };
}

export default connect(mapStateToProps)(RunscriptOutputsSection);



/** WEBPACK FOOTER **
 ** ./src/components/RunscriptOutputsSection.js
 **/